/* eslint-disable react/no-unescaped-entities */
"use client";

import React, { useState, useRef, useEffect } from "react";

import Heading from "@/components/heading/heading";
import Button from "@/components/button/Button";

import Arrow from "@/public/svg/arrow-right.svg";
import Buttonwhatsapp from "@/public/svg/common/social-icons/whatsapp.svg";
import RightIcon from "@/public/svg/line-arrow-right.svg";

import Image from "next/image";

import "@/sections/common/tariff/tariff.scss";

const Tariff = () => {
    const [showSecondContainer, setShowSecondContainer] = useState(false);
    const secondContainerRef = useRef<HTMLDivElement | null>(null);

    const handleViewMore = () => {
        setShowSecondContainer(true);
    };

    const handleViewLess = () => {
        setShowSecondContainer(false);

        const familyPackagesElement = document.getElementById("tariffsection");
        if (familyPackagesElement) {
            familyPackagesElement.scrollIntoView({ behavior: "smooth" });
        }
    };

    useEffect(() => {
        if (secondContainerRef.current) {
            if (showSecondContainer) {
                // Set max-height to the actual height of the content for smooth transition
                const contentHeight = secondContainerRef.current.scrollHeight;
                secondContainerRef.current.style.maxHeight = `${contentHeight}px`;
            } else {
                secondContainerRef.current.style.maxHeight = "0";
            }
        }
    }, [showSecondContainer]);

    return (
        <section className="tariff-section pt-6" id="tariffsection">
            <div className="container px-4 mx-auto">
                <div className="tariff-wrapper flex flex-col gap-6 p-3 md:p-6">
                    <div className="tariff-head pb-3">
                        <Heading as="h2">
                            Malaysia Tour Packages from India for Family
                        </Heading>
                    </div>
                    <div className="tariff-body-footer flex flex-col gap-4">
                        <div className="tariff-body flex flex-col gap-4 px-3 md:px-6">
                            <div className="flex flex-col gap-4">
                                <p className="lead">
                                    Are you ready to escape for family
                                    adventures? Dimaak Tours offers easy
                                    Malaysia tour packages from India for
                                    families, giving you a unique chance to
                                    visit top destinations in Malaysia.
                                    {!showSecondContainer && (
                                        <span
                                            className="font-medium view-more ml-4 cursor-pointer text-blue-600 hover:text-blue-800"
                                            onClick={handleViewMore}
                                        >
                                            View More
                                        </span>
                                    )}
                                </p>
                            </div>
                            <div
                                id="second-container"
                                ref={secondContainerRef}
                                className={`transition-all duration-500 overflow-hidden ${
                                    showSecondContainer
                                        ? "max-h-full opacity-100"
                                        : "max-h-0 opacity-0"
                                }`}
                            >
                                <div className="flex flex-col gap-4">
                                    <p className="lead">
                                        Indian tourists prefer Malaysia for
                                        family vacations because of its diverse
                                        cultures, beautiful landscapes, and
                                        history. Malaysia offers a cozy and
                                        family-friendly destination to travel
                                        with kids.
                                    </p>
                                    <p className="lead">
                                        Dimaak Tours provides a budget-friendly
                                        family package with a customized
                                        itinerary for Malaysia. Track down
                                        Malaysia's diverse attractions and have
                                        the best experience with Dimaak.
                                    </p>
                                    <Heading as="h3">
                                        Why Choose Malaysia for a Family Trip
                                    </Heading>
                                    <p className="lead">
                                        Malaysia's blend of culture with
                                        modernity offers a unique experience for
                                        every family member.
                                    </p>
                                    <p className="lead">
                                        The main reasons are:{" "}
                                    </p>
                                    <ul>
                                        <li>Offers warm hospitality</li>
                                        <li>
                                            Incredible architectural designs of
                                            shrines, mosques and temples
                                        </li>
                                        <li>
                                            Convenient family accommodations
                                        </li>
                                        <li>
                                            Breathtaking scenery, lush
                                            rainforest, and beautiful beaches
                                        </li>
                                        <li>
                                            Experience a safe and comfortable
                                            journey
                                        </li>
                                        <li>
                                            Offers a diverse cuisine and a
                                            culinary adventure.
                                        </li>
                                    </ul>
                                    <Heading as="h3">
                                        Malaysia Family Tour Packages From India
                                    </Heading>
                                    <p className="lead">
                                        Dimaak Tours offers a wide range of
                                        Malaysia family tour packages that cater
                                        to your needs and preferences from
                                        India.
                                    </p>
                                    <p className="lead">
                                        Explore our packages featuring
                                        personalized itineraries for your ideal
                                        destinations. Our local experts are
                                        available 24/7 to ensure your family has
                                        a smooth and memorable trip.
                                    </p>
                                    <p className="lead">
                                        You can choose a package from various
                                        options, whether looking for a
                                        refreshing beach or an adventurous
                                        experience. To know more, check out the
                                        details below.
                                    </p>
                                    <div className="table-custom">
                                        <div className="row flex flex-wrap justify-around gap-5">
                                            <div className="columns-4 flex flex-col items-center gap-3">
                                                <div className="card-content flex flex-col items-center">
                                                    <p className="lead">
                                                        Experience Malaysia with
                                                        our 3 Nights, 4 Days
                                                        tour packages
                                                    </p>
                                                </div>
                                                <div className="flex items-center justify-between w-full">
                                                    <p className="lead">
                                                        <strong>
                                                            Starts from
                                                            Rs.17,999/-
                                                        </strong>
                                                    </p>
                                                    <a
                                                        target="_blank"
                                                        href="https://wa.me/919600099777?text=Hi,%20I%20am%20Interested%20in%20Malaysia%20Family%20Packages."
                                                        className="quote-link flex items-center gap-3"
                                                    >
                                                        <Image
                                                            src={Buttonwhatsapp}
                                                            alt="whatsappimage"
                                                        />
                                                        Get Quote
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="columns-4 flex flex-col items-center gap-3">
                                                <div className="card-content flex flex-col items-center">
                                                    <p className="lead">
                                                        Explore Malaysia with
                                                        our 4 Nights, 5 Days
                                                        tour packages
                                                    </p>
                                                </div>
                                                <div className="flex items-center justify-between w-full">
                                                    <p className="lead">
                                                        <strong>
                                                            Start from
                                                            Rs.30,799/-
                                                        </strong>
                                                    </p>
                                                    <a
                                                        target="_blank"
                                                        href="https://wa.me/919600099777?text=Hi,%20I%20am%20Interested%20in%20Malaysia%20Family%20Packages."
                                                        className=" quote-link flex items-center gap-3"
                                                    >
                                                        <Image
                                                            src={Buttonwhatsapp}
                                                            alt="whatsappimage"
                                                        />
                                                        Get Quote
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="flex flex-col gap-4">
                                    <Heading as="h3">
                                        Streamline Your Flight Booking
                                        Experiences
                                    </Heading>
                                    <p className="lead">
                                        The leading international flights
                                        available from India to Malaysia are
                                        AirAsia, Malaysia Airlines, and IndiGo.
                                        These flights operate at various times,
                                        providing flexibility for your travel
                                        plans.
                                    </p>
                                    <p className="lead">
                                        The flight cost varies depending on the
                                        airline, time of booking, travel dates,
                                        and season. However, a round-trip ticket
                                        costs approximately INR 6,000 to INR
                                        30,000 per person.
                                    </p>
                                    <Heading as="h3">
                                        Where to Book Flights
                                    </Heading>
                                    <p className="lead">
                                        Check these popular websites to book
                                        your flight tickets: Skyscanner, Yatra,
                                        MakeMyTrip, EaseMyTrip, and Clear Trip.
                                        These websites provide a convenient way
                                        to compare prices and book flights.
                                        Apart from these, Dimaak Tours will
                                        provide you with proper guidance. Here
                                        are some of the flights to know:
                                    </p>
                                    <Heading as="h3">
                                        Flights from India to Malaysia
                                    </Heading>
                                    <ul>
                                        <li>
                                            Mumbai to Kuala Lumpur, 2 stops- The
                                            price starts at Rs. 13,760.
                                        </li>
                                        <li>
                                            Bangalore to Kuala Lumpur non-stop-
                                            The price starts at Rs. 14,189.
                                        </li>
                                        <li>
                                            Chennai to Langkawi, 1 stop- The
                                            price starts at Rs. 6,452.
                                        </li>
                                        <li>
                                            Hyderabad to Kuala Lumpur non-stop-
                                            The price starts at Rs. 16,891.
                                        </li>
                                    </ul>
                                </div>
                                <div className="flex flex-col gap-4">
                                    <Heading as="h3">
                                        Ideal Time to Visit Malaysia with Your
                                        Family
                                    </Heading>
                                    <p className="lead">
                                        Malaysia gladly welcomes travelers all
                                        year round. The best time to visit is
                                        from June to August when the weather is
                                        pleasant, and you can enjoy plenty of
                                        outdoor activities.
                                    </p>
                                    <p className="lead">
                                        A good time to visit is from November to
                                        March when the weather is nice for
                                        exploring sites with loved ones. Choose
                                        your best time and make memories that
                                        last a lifetime.
                                    </p>
                                    <Heading as="h3">
                                        Where to Stay in Malaysia with Family
                                    </Heading>
                                    <p className="lead">
                                        Malaysia features a variety of
                                        family-friendly hotel accommodations,
                                        ranging from budget hotels to luxury
                                        resorts. The best places to stay are
                                        Kuala Lumpur, Langkawi, Genting
                                        Highlands, Penang, and Cameron
                                        Highlands.
                                    </p>
                                    <p className="lead">
                                        Families visiting Kuala Lumpur can stay
                                        in city center hotels near their chosen
                                        attractions for easier navigation.
                                    </p>
                                    <ul>
                                        <li>
                                            The{" "}
                                            <a
                                                target="_blank"
                                                href="https://www.furama.com/bukitbintang"
                                            >
                                                {" "}
                                                <i>
                                                    <u>
                                                        Furama Bukit Bintang
                                                        Hotel
                                                    </u>
                                                </i>
                                            </a>{" "}
                                            has jungle-themed accommodations.
                                        </li>
                                        <li>
                                            <a
                                                target="_blank"
                                                href="https://www.shangri-la.com/kualalumpur/shangrila/"
                                            >
                                                <i>
                                                    <u>
                                                        Shangri-La Kuala Lumpur
                                                    </u>
                                                </i>
                                            </a>{" "}
                                            has a huge swimming pool for
                                            families and a view of the KL Tower.
                                            Both hotels welcome families and
                                            provide ample accommodations,
                                            breakfast, and refreshments.
                                        </li>
                                    </ul>
                                    <p className="lead">
                                        <strong>Langkawi</strong> has beachside
                                        resorts with swimming pools, kids'
                                        clubs, and water sports facilities.
                                    </p>
                                    <ul>
                                        <li>
                                            The{" "}
                                            <a
                                                target="_blank"
                                                href="https://www.marriott.com/en-us/hotels/lgkwi-the-westin-langkawi-resort-and-spa/overview/?scid=f2ae0541-1279-4f24-b197-a979c79310b0"
                                            >
                                                {" "}
                                                <i>
                                                    <u>
                                                        Westin Langkawi Resort &
                                                        Spa
                                                    </u>
                                                </i>
                                            </a>{" "}
                                            is perfect for a pleasant and cozy
                                            stay. You can explore the city at
                                            your leisure, visiting Padang
                                            Matsirat, Eagle Square, and Legenda
                                            Park.{" "}
                                        </li>
                                        <li>
                                            <a
                                                target="_blank"
                                                href="https://www.pelangiresort.com/"
                                            >
                                                <i>
                                                    <u>
                                                        Pelangi Beach Resort &
                                                        Spa
                                                    </u>
                                                </i>
                                            </a>{" "}
                                            features a beach around an
                                            artificial lake and a lagoon-style
                                            swimming pool. You can experience
                                            the nearby places, such as Island
                                            Hopping, Underwater World Langkawi,
                                            Langkawi International Airport.{" "}
                                        </li>
                                    </ul>
                                    <p className="lead">
                                        <strong>Genting Highlands</strong>{" "}
                                        enjoys the weather at the top of the
                                        hills.
                                    </p>
                                    <ul>
                                        <li>
                                            The{" "}
                                            <a
                                                target="_blank"
                                                href="https://www.rwgenting.com/en/hotels/crockfords.html"
                                            >
                                                {" "}
                                                <i>
                                                    <u>
                                                        Crockfords Resorts World
                                                        Genting
                                                    </u>
                                                </i>
                                            </a>{" "}
                                            has fancy rooms, great amenities,
                                            and a semi-buffet dining option for
                                            a cozy stay.{" "}
                                        </li>
                                        <li>
                                            <a
                                                target="_blank"
                                                href="https://www.resortsworldglobal.genting/rwawana"
                                            >
                                                <i>
                                                    <u>Resorts World Awana</u>
                                                </i>
                                            </a>{" "}
                                            nestles on a hill and offers
                                            panoramic landscapes, nature walks,
                                            golf, and mouth-watering cuisine.
                                            You can explore the Awana Skyway
                                            Genting Skyworld Theme Park.
                                        </li>
                                    </ul>
                                    <p className="lead">
                                        <strong>Penang</strong>{" "}
                                        <a
                                            target="_blank"
                                            href="https://www.shangri-la.com/penang/goldensandsresort/"
                                        >
                                            {" "}
                                            <i>
                                                <u>Shangri-La Golden Sands</u>
                                            </i>
                                        </a>{" "}
                                        offers pools, a mini waterpark, and a
                                        central whirlpool on Batu Ferringhi
                                        Beach. You can visit Georgetown, a
                                        UNESCO site easily accessible from the
                                        hotel.
                                    </p>
                                    <p className="lead">
                                        <strong>Cameron Highlands,</strong>{" "}
                                        <a
                                            target="_blank"
                                            href="https://lakehouse-cameron.com/?utm_source=gmb&utm_medium=link&utm_campaign=gmb_hotel_listing"
                                        >
                                            {" "}
                                            <i>
                                                <u>The Lakehouse</u>
                                            </i>
                                        </a>{" "}
                                        is a boutique-style hotel. The resort
                                        arranges airport transfer services. You
                                        can explore the drive to Cameron Tea
                                        Estate, Agro Technology Par, and Time
                                        Tunnel Museum.
                                    </p>
                                </div>
                                <div className="flex flex-col gap-4">
                                    <Heading as="h3">
                                        Must Visit Places in Malaysia with Your
                                        Family
                                    </Heading>
                                    <p className="lead">
                                        Encounter Malaysia's treasures for
                                        families and captivate the diverse
                                        attractions. Experience the magic,
                                        immerse yourself in a family tour of
                                        Malaysia, and capture loved ones'
                                        hearts.
                                    </p>
                                    <p className="lead">
                                        Malaysia is home to several
                                        family-friendly destinations. Explore
                                        the best of Kuala Lumpur, Genting
                                        Highlands, Langkawi, Penang, Cameron
                                        Highlands, Kota Kinabalu, and Ipoh.
                                    </p>
                                    <ul>
                                        <li>
                                            <strong>Kuala Lumpur</strong> is a
                                            modern city with family-friendly
                                            attractions like the Petronas Twin
                                            Towers, KLCC Park, and shopping.
                                            Visitors can also explore shrines
                                            and temples in the area.
                                        </li>
                                        <li>
                                            <strong>Genting Highlands</strong>,
                                            families can enjoy the sky cab over
                                            the mountains and casinos.
                                        </li>
                                        <li>
                                            <strong>Langkawi</strong> families
                                            can relax on the beach, explore the
                                            mangrove forest, and visit the
                                            Langkawi Sky Bridge.
                                        </li>
                                        <li>
                                            In <strong>Penang</strong>, families
                                            can explore historic Georgetown, see
                                            street art, visit Penang Hills and
                                            Meromictic Lake, and enjoy Penang
                                            National Park.
                                        </li>
                                        <li>
                                            Families can enjoy the cool climate
                                            in{" "}
                                            <strong>Cameron Highlands</strong>,
                                            visit the tea plantations, and visit
                                            the strawberry farms.
                                        </li>
                                        <li>
                                            Families can visit the City Mosque
                                            in <strong>Kota Kinabalu</strong>,
                                            do water sports, and explore the
                                            Marine Park.{" "}
                                        </li>
                                        <li>
                                            <strong>On Ipoh Island</strong>,
                                            visit Colonial Architecture, The
                                            Birch Memorial Clock Tower, Street
                                            Art, and enjoy the Old Town
                                            Laneways.
                                        </li>
                                    </ul>
                                    <Heading as="h3">
                                        Kids-Friendly Places to Visit in
                                        Malaysia
                                    </Heading>
                                    <p className="lead">
                                        Fun places for kids, like Sunway Lagoon,
                                        Legoland Malaysia, and the Lost World of
                                        Tambun, are waiting for you to visit.
                                    </p>
                                    <ul>
                                        <li>
                                            <strong>Sunway Lagoon</strong> has
                                            80 fun things to do, including
                                            amusement and water parks, wildlife
                                            encounters, and a scream park.
                                        </li>
                                        <li>
                                            <strong>Legoland Malaysia</strong>{" "}
                                            offers fun for all ages with two
                                            theme parks: Legoland Theme Park and
                                            Legoland Water Park. Enjoy 40
                                            interactive rides, attractions, and
                                            shows.
                                        </li>
                                        <li>
                                            <strong>
                                                Lost World of Tambun
                                            </strong>{" "}
                                            lies in Ipoh. It cools kids from the
                                            humid temperature and offers many
                                            adventurous activities.
                                        </li>
                                    </ul>
                                    <Heading as="h3">
                                        What Are The Must-Do Things in Malaysia
                                    </Heading>
                                    <p className="lead">
                                        Plenty of activities await! Here are
                                        some adventure experiences to add to
                                        your Malaysia bucket list.
                                    </p>
                                    <ul>
                                        <li>
                                            <strong>Chin-Swee Temple</strong>,
                                            known for the metaphysical powers of
                                            Buddhist saint Chin Swee, is the
                                            most picturesque Genting Highlands
                                            site.
                                        </li>
                                        <li>
                                            <strong>Seri Wawasan Bridge</strong>{" "}
                                            Cross the elegant masterpiece of
                                            Seri Wawasan Bridge, which connects
                                            Putrajaya, you can enjoy the scenic
                                            beauty and capture the moments.
                                        </li>
                                        <li>
                                            <strong>Cable Car Ride</strong> A
                                            sky-high adventure above lush
                                            landscapes and sea level. Relish
                                            panoramic views and create a family
                                            reminiscence of Malaysia's natural
                                            beauty.
                                        </li>
                                        <li>
                                            <strong>
                                                Shop in Chinatown and Hanifa,
                                            </strong>{" "}
                                            a vibrant market center around
                                            Petaling Street in Kuala Lumpur. You
                                            can see designer clothing, handbags,
                                            handicrafts, electronics, souvenirs,
                                            fruits, vegetables, and spices.
                                        </li>
                                        <li>
                                            <strong>
                                                Kinabatangan River Safari
                                            </strong>{" "}
                                            is abundant in flora and fauna. An
                                            excellent ride through the tropical
                                            lowland rainforest, rich in
                                            ecosystems, awaits.
                                        </li>
                                        <li>
                                            <strong>
                                                Snorkeling and diving
                                            </strong>{" "}
                                            are thrilling experiences of the
                                            underwater world in the azure
                                            depths, from pristine coral reefs to
                                            diverse marine life. The best
                                            Snorkeling destinations are the
                                            Perhentian Islands, Redang Island,
                                            and Tioman Island.
                                        </li>
                                        <li>
                                            <strong>
                                                Sunway Lagoon Extreme Park is
                                            </strong>{" "}
                                            also known as Sunway Lagoon X Park.
                                            Try bungee jumping, target shooting,
                                            kayaking, or pedal boating with your
                                            family for exciting adventures and
                                            experiences.
                                        </li>
                                        <li>
                                            <strong>
                                                Farm in the City, Seri
                                                Kembangan,
                                            </strong>{" "}
                                            enables toddlers to experience and
                                            interact with animals and nature.
                                        </li>
                                        <li>
                                            <strong>
                                                In Kidzania, Curve NX,
                                            </strong>{" "}
                                            children can choose their careers,
                                            helping them learn essential skills
                                            and lessons for the future. A fun
                                            way to prepare them for the real
                                            world.
                                        </li>
                                    </ul>
                                    <Heading as="h3">
                                        Things You Should Know if You Are
                                        Traveling with Kids
                                    </Heading>
                                    <p className="lead">
                                        Traveling with kids requires extra
                                        preparation. Here are some tips for
                                        backpacking while traveling.
                                    </p>
                                    <ul>
                                        <li>
                                            Pack a lightweight bag and bring
                                            essentials such as snacks, water,
                                            and entertainment for the kids.
                                        </li>
                                        <li>
                                            Wet wipes and toilet paper are
                                            essential to carry while traveling
                                            with kids.
                                        </li>
                                        <li>
                                            Wear slip-on shoes, wool T-shirts,
                                            and sleeved shirts, and carry a dual
                                            USB travel adaptor.{" "}
                                        </li>
                                        <li>
                                            Carry a stroller for kids for easy
                                            mobility; if not, consider renting
                                            one for your convenience. Renting
                                            services in Kuala Lumpur{" "}
                                            <a
                                                target="_blank"
                                                href="https://www.babonbo.com/en/search/kuala-lumpur/MY"
                                            >
                                                <u>Rent Baby Gear</u>
                                            </a>
                                            ,{" "}
                                            <a
                                                target="_blank"
                                                href="https://www.kl-babygearrental.my/rental_sewa/kuala-lumpur-baby-gear-rental/"
                                            >
                                                <u>
                                                    Stroller Baby & Child Seat
                                                    Rental
                                                </u>
                                            </a>
                                            , and{" "}
                                            <a
                                                target="_blank"
                                                href="https://www.carousell.com.my/babies-kids/strollers/stroller-rent/q-629/?addRecent=false&canChangeKeyword=false&includeSuggestions=false&sc=0a0208301a0408b5e36922110a0d7374726f6c6c65722072656e7478012a160a0b636f6c6c656374696f6e7312050a0336323978013204080178013a02180842060801100118004a08200128014001480150005a020801&searchId=WwGhuk&sort_by=1"
                                            >
                                                <u>Stroller Rent</u>
                                            </a>
                                            .
                                        </li>
                                        <li>
                                            Make sure your kids are up-to-date
                                            on their vaccinations before
                                            traveling to Malaysia.
                                        </li>
                                        <li>
                                            Obtain travel insurance to protect
                                            your family against unexpected
                                            emergencies.
                                        </li>
                                        <li>
                                            Check the visa for Malaysia, but
                                            there is no visa for Malaysia from
                                            India till December 2024.
                                        </li>
                                        <li>
                                            Look for Indian restaurants to
                                            ensure your kids have familiar food.
                                        </li>
                                    </ul>
                                    <Heading as="h3">Conclusion</Heading>
                                    <p className="lead">
                                        Malaysia entices rich culture, modern
                                        benefits, and magnificent landscapes. A
                                        warm hospitality makes it an ideal
                                        destination for memorable family
                                        adventures.
                                    </p>
                                    <p className="lead">
                                        So, why wait? Book your family tour
                                        package for Malaysia with Dimaak Tours
                                        to capture memories of treasure for a
                                        lifetime. Let us be your travel partner,
                                        ensuring a smooth and fantastic trip for
                                        your family.
                                    </p>
                                    <p className="lead">
                                        Make your family's dream vacation a
                                        reality. Malaysia awaits; let the
                                        adventure begin!
                                    </p>
                                    <Heading as="h3">FAQs</Heading>
                                    <Heading as="h4">
                                        Which is the best family holiday
                                        destination in Malaysia?
                                    </Heading>
                                    <p className="lead">
                                        Malaysia has many family-friendly
                                        destinations, including Kuala Lumpur,
                                        which blends culture, relaxation, and
                                        entertainment. Other places include
                                        Langkawi, Georgetown Penang, Genting
                                        Highlands, Cameron Highlands, and Kota
                                        Kinabalu.
                                    </p>
                                    <Heading as="h4">
                                        What are the must-visit places for
                                        memorable family vacations?
                                    </Heading>
                                    <p className="lead">
                                        Explore Malaysia from the iconic Twin
                                        Towers to the mystical charm of Batu
                                        caves with shrines and temples, the
                                        vibrant culture in Little India, the
                                        natural wonders of Semenggoh Nature
                                        Reserve, the thrilling adventures of
                                        Legoland and Sunway Lagoon, to the
                                        mesmerizing underwater world at KLCC
                                        Aquaria.
                                    </p>
                                    <Heading as="h4">
                                        What can you do with your family in
                                        Malaysia?
                                    </Heading>
                                    <p className="lead">
                                        Unlatch a plentitude of family-friendly
                                        activities, from theme parks to scuba
                                        diving. Enjoy beginner-friendly jungle
                                        trekking at Taman Negara and Penang Hill
                                        for a thrilling experience. Fill your
                                        days with joy on your journey with this
                                        hiking trail.
                                    </p>
                                    <Heading as="h4">
                                        What are the top places to stay in
                                        Malaysia?
                                    </Heading>
                                    <p className="lead">
                                        <strong>Pangkor Laut Resort</strong>{" "}
                                        replicates the modern world with a sea
                                        eagle circle. It offers games, sports
                                        courts, an infinity pool, and water
                                        sports.
                                    </p>
                                    <p className="lead">
                                        <strong>
                                            Shangri-La's Rasa Ria Resort and Spa
                                        </strong>{" "}
                                        features an elegant room, extensive
                                        dining facilities, and a kid's club.
                                    </p>
                                    <p className="lead">
                                        <strong>Parkroyal Penang Resort</strong>{" "}
                                        indulges in luxury and is renowned for
                                        its exquisite Malay cuisine. It features
                                        a delightful array of continental,
                                        Western, and Asian buffets complemented
                                        by enchanting cocktails.
                                    </p>
                                </div>
                            </div>
                        </div>
                        {showSecondContainer && (
                            <div className="traffic-footer flex-wrap flex items-center justify-evenly gap-3 md:gap-5 pt-4">
                                <div>
                                    <a
                                        target="_blank"
                                        href="https://wa.me/919600099777?text=Hi,%20I%20am%20Interested%20in%20Malaysia%20Family%20Packages."
                                    >
                                        <Button
                                            className="flex items-center gap-3"
                                            variant="green"
                                            onClick={handleViewLess}
                                        >
                                            <Image
                                                src={Buttonwhatsapp}
                                                alt="whatsappimage"
                                            />
                                            <span>Get Quote</span>
                                        </Button>
                                    </a>
                                </div>
                                <div
                                    className="flex items-center gap-3 cursor-pointer"
                                    onClick={handleViewLess}
                                >
                                    <span className="text-link">View Less</span>
                                    <Image src={RightIcon} alt="right icon" />
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Tariff;
